<template>
<div>
  <vue-headful :title="site_title" />
  <Header />
  <!-- pages widget -->
  <template v-if="this.response">
    <template v-if="this.response.pms">
      <table class="pms__wrappertable" width="100%">
        <tr>
          <!--left side -->
          <td width="24%" valign="top">
            <UserControlPanel :inbox="this.response['inbox']" :outbox="this.response['outbox']" :unsent="this.response['unsent']" />
          </td>

          <!-- empty separator -->
          <td width="1%"></td>

          <!--right side -->
          <td width="75%" valign="top">
            <div class="ucp__content">
              <div class="ucp__content_header">Добро пожаловать в ваши личные данные </div>

              <div class="ucp__content_subtitle">
                <template v-if="$route.query.VID && $route.query.VID == 'sent'">
                  Sent Items
                </template>
                <template v-else-if="$route.query.VID && $route.query.VID == 'unsent'">
                  Сохраненные неотправленные сообщения
                </template>
                <template v-else>
                  Inbox
                </template>
              </div>

              <div class="pms__folder_info_div">
                <table class="pms__wrappertable pms__folders_info" width="100%">
                  <tr>
                    <td>
                      <table class="pms__wrappertable" width="300px">
                        <tr>
                          <td class="row1" colspan="3">Ваши папки заполнены на 0%</td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <img src="../assets/bar_left.gif">
                            <img src="../assets/bar.gif" width="1" height="11">
                            <img src="../assets/bar_right.gif">
                          </td>
                        </tr>
                        <tr>
                          <td width="33%">0%</td>
                          <td width="33%" align="center">50%</td>
                          <td width="33%" align="right">100%</td>
                        </tr>
                      </table>
                    </td>
                    <td align="right">
                      <br><br>
                      <a>Отметить прочитанные сообщения</a> :: <a>Снять все отметки</a>
                      <br><br>
                      <!-- Перейти в папку: -->
                    </td>
                  </tr>
                </table>
              </div>

              <div class="pms__messages_table_div">
                <table class="pms__message_table" width="100%">
                  <tr>
                    <th width="5%"><span v-html="nbsp"></span></th>
                    <th width="35%"><span><a><b>Заголовок сообщения</b></a></span></th>
                    <th width="30%"><span><a><b>
                            <template v-if="$route.query.VID && $route.query.VID == 'sent'">
                              Это сообщение отправлено для
                            </template>
                            <template v-else-if="$route.query.VID && $route.query.VID == 'unsent'">
                              Сообщение для
                            </template>
                            <template v-else>
                              Отправитель
                            </template>
                          </b></a></span></th>
                    <th width="25%"><span><a><b>
                            <template v-if="$route.query.VID && $route.query.VID == 'unsent'">
                              Дата сохранения
                            </template>
                            <template v-else>
                              Дата
                            </template>
                          </b></a></span></th>
                    <th style="text-align: center;" width="5%"><span><input type="checkbox"></span></th>
                  </tr>
                  <template v-if="this.response.pms.length === 0">
                    <tr>
                      <td colspan="5" align="center"><b>Сообщений не обнаружено</b></td>
                    </tr>
                  </template>
                  <tr v-for="pm in this.response.pms">
                    <td align="center" valign="middle"><img src="../assets/f_norm_no.gif"></td>
                    <td><a :href="'index.php?act=Msg&MSID='+pm.id">{{htmlDecode(pm.title)}}</a></td>
                    <td><a :href="'index.php?showuser='+pm.posterid">{{htmlDecode(pm.postername)}}</a></td>
                    <td>{{pm.sentdate | formatDate}}</td>
                    <td style="text-align: center;"><input type="checkbox"></td>
                  </tr>
                </table>
              </div>

              <div class="pms__post_info">
                <div style="width: 50%;">
                  <img style="vertical-align:middle;" src="../assets/f_norm_no.gif"> Прочитанные сообщения<br>
                  <img style="vertical-align:middle;" src="../assets/f_norm.gif"> Непрочитанные сообщения
                </div>
                <div style="width: 50%; text-align:right"><br><i>У вас {{this.response['inbox'] + this.response['outbox'] + this.response['unsent']}} личных сообщений из 10000 максимально возможных</i></div>
              </div>

            </div>
          </td>
        </tr>
      </table>
      <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.response.queries" />
    </template>
    <template v-else>
      Пожалуйста перелогиньтесь.
    </template>
  </template>
</div>
</template>

<script>
import Header from './Header'
import UserControlPanel from './UserControlPanel'
import FooterPermanent from './FooterPermanent'

export default {
  components: {
    Header,
    FooterPermanent,
    UserControlPanel,
  },
  data: function() {
    return {
      response: null,
      footerReady: false
    }
  },
  async created() {
    let dateEarly = new Date();
    let response = null;
    if (this.$route.query.VID && this.$route.query.VID == "sent") {
      response = await fetch(this.getNodePath() + 'pms/sent/');
    } else if (this.$route.query.VID && this.$route.query.VID == "unsent") {
      response = await fetch(this.getNodePath() + 'pms/unsent/');
    } else {
      response = await fetch(this.getNodePath() + 'pms/');
    }
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    this.footerReady = true;
  }
}
</script>

<style lang="scss">
@import "./PMs.scss";
</style>
